import { Component, OnInit } from '@angular/core';
import { MainPortalService } from '../../../services/main-portal.service';
import { GenericFiltrationContract } from 'projects/shared/models/GenericFiltrationContract';
import { GenericListContract } from 'projects/shared/models/GenericListContract';
import { GenericResponseContract } from 'projects/shared/models/GenericResponseContract';
import { Globals } from 'projects/shared/models/Globals';
import { GenericListItemContract } from 'projects/shared/models/GenericListItemContract';

declare var parentId: any;
declare var isChild: any;
declare var isEshop:any;
declare var productKey:any;
@Component({
  selector: 'app-related-content',
  templateUrl: './related-content.component.html',
  styleUrls: []
})

export class RelatedContentComponent implements OnInit {
  public items: any[] = new Array();
  static pageIndex = 1;
  input = new GenericFiltrationContract(parentId, RelatedContentComponent.pageIndex, 4, Globals.SecondaryListingCrop, 250);
  globals;
  hideShowMoreButton = false;
  isChild = isChild;
  
  constructor(private data: MainPortalService) 
  { 
    this.globals = Globals;
  }

  ngOnInit() {
    this.input.isEshop=isEshop;
    this.input.productKey=productKey;
    this.data.getRelatedContent(this.input).subscribe((response: GenericResponseContract<GenericListContract<GenericListItemContract>>) =>{
      this.items = this.items.concat(response.Data.ListItems),
        this.checkItemsCount(this.items.length, response.Data.Count);
    });
  }

  checkItemsCount(itemsCount: number, totalCount: number){
    if(itemsCount == 0 || itemsCount == totalCount)
      this.hideShowMoreButton = true;
    else 
      this.hideShowMoreButton = false;  
  }

  onShowMoreClick(){
    if(++RelatedContentComponent.pageIndex > 1 && this.items.length >= 4){
      this.input = new GenericFiltrationContract(parentId, RelatedContentComponent.pageIndex, 4, Globals.SecondaryListingCrop, 250);
      this.ngOnInit();
    }
  }

}
